/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * modifier object
 * @export
 * @interface GetDogmaEffectsEffectIdModifier
 */
export interface GetDogmaEffectsEffectIdModifier {
    /**
     * domain string
     * @type {string}
     * @memberof GetDogmaEffectsEffectIdModifier
     */
    domain?: string;
    /**
     * effect_id integer
     * @type {number}
     * @memberof GetDogmaEffectsEffectIdModifier
     */
    effectId?: number;
    /**
     * func string
     * @type {string}
     * @memberof GetDogmaEffectsEffectIdModifier
     */
    func: string;
    /**
     * modified_attribute_id integer
     * @type {number}
     * @memberof GetDogmaEffectsEffectIdModifier
     */
    modifiedAttributeId?: number;
    /**
     * modifying_attribute_id integer
     * @type {number}
     * @memberof GetDogmaEffectsEffectIdModifier
     */
    modifyingAttributeId?: number;
    /**
     * operator integer
     * @type {number}
     * @memberof GetDogmaEffectsEffectIdModifier
     */
    operator?: number;
}

/**
 * Check if a given object implements the GetDogmaEffectsEffectIdModifier interface.
 */
export function instanceOfGetDogmaEffectsEffectIdModifier(value: object): value is GetDogmaEffectsEffectIdModifier {
    if (!('func' in value) || value['func'] === undefined) return false;
    return true;
}

export function GetDogmaEffectsEffectIdModifierFromJSON(json: any): GetDogmaEffectsEffectIdModifier {
    return GetDogmaEffectsEffectIdModifierFromJSONTyped(json, false);
}

export function GetDogmaEffectsEffectIdModifierFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDogmaEffectsEffectIdModifier {
    if (json == null) {
        return json;
    }
    return {
        
        'domain': json['domain'] == null ? undefined : json['domain'],
        'effectId': json['effect_id'] == null ? undefined : json['effect_id'],
        'func': json['func'],
        'modifiedAttributeId': json['modified_attribute_id'] == null ? undefined : json['modified_attribute_id'],
        'modifyingAttributeId': json['modifying_attribute_id'] == null ? undefined : json['modifying_attribute_id'],
        'operator': json['operator'] == null ? undefined : json['operator'],
    };
}

export function GetDogmaEffectsEffectIdModifierToJSON(json: any): GetDogmaEffectsEffectIdModifier {
    return GetDogmaEffectsEffectIdModifierToJSONTyped(json, false);
}

export function GetDogmaEffectsEffectIdModifierToJSONTyped(value?: GetDogmaEffectsEffectIdModifier | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'domain': value['domain'],
        'effect_id': value['effectId'],
        'func': value['func'],
        'modified_attribute_id': value['modifiedAttributeId'],
        'modifying_attribute_id': value['modifyingAttributeId'],
        'operator': value['operator'],
    };
}

